import { NodeSpec, Node as ProsemirrorNode, DOMOutputSpec } from "prosemirror-model";
import { createStyleAttributeHandlers, StyleAttributes } from "./attributes/styleAttributes";

const stylesToCopy = {
	"width": "width",
	"height": "height"
} as const;

type ImageStyleKeysToCopy = keyof typeof stylesToCopy;

const {
	getStyleAttributes,
	setStyleAttributes,
	styleAttributeDefinitions
} = createStyleAttributeHandlers(
	stylesToCopy
);

export type ImageNodeAttributes = StyleAttributes<ImageStyleKeysToCopy> & {
	src: string;
	alt: string | null;
	title: string | null;
};

export const image: NodeSpec = {
	inline: true,
	attrs: {
		...styleAttributeDefinitions,
		src: {},
		alt: {default: null},
		title: {default: null}
	},
	group: "inline",
	draggable: true,
	parseDOM: [
		{
			tag: "img[src]",
			getAttrs(node: Node | string): ImageNodeAttributes | false {
				if (!(node instanceof HTMLImageElement)) {
					throw new Error("Expected HTMLImageElement at this point");
				}

				const styleAttributes: StyleAttributes<ImageStyleKeysToCopy> = getStyleAttributes(node);

				return {
					...styleAttributes,
					src: node.src ?? "",
					title: node.title ?? null,
					alt: node.alt ?? null
				};
			}
		}
	],
	toDOM(node: ProsemirrorNode): DOMOutputSpec {
		const attrs = node.attrs as ImageNodeAttributes;
		const {
			src,
			alt,
			title
		} = attrs;

		return [
			"img",
			{
				src,
				alt,
				title,
				style: setStyleAttributes(attrs)
			}
		];
	}
};